import { AuthService } from './../../service/auth.service';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AlertService } from '../../service/alert.service';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from "@angular/material/icon";
import { AlertMessageComponent } from "../../shared/alert-message/alert-message.component";
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {MatCheckboxModule} from '@angular/material/checkbox';


@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  imports: [MatIcon, AlertMessageComponent, CommonModule, FormsModule, ReactiveFormsModule,RouterModule, TranslateModule, MatCheckboxModule]
})
export class LoginComponent {

  constructor(private http: HttpClient, private router: Router, 
    private authService: AuthService, private alertService: AlertService, private translate: TranslateService) {}

  email: string = '';
  password: string = '';
  showPassword : boolean = false;

  login(form: NgForm) {
    if (!form.valid) {
      this.alertService.errorKey('auth.errors.required-fields');
      return;
    }

    this.authService.login(this.email, this.password).subscribe({
      next: (token: string) => {
        this.authService.setToken(token);
        console.log('login fatto')
        this.router.navigate(['/dashboard']);
      },
      error: (err) => {
        const backendMessage =
          typeof err?.error === 'string'
            ? err.error
            : typeof err?.error?.message === 'string'
              ? err.error.message
              : '';

        this.alertService.errorKey(
          this.translateLoginErrorKey(backendMessage) || 'auth.login.errors.generic'
        );
      }
    });
  }

  private translateLoginErrorKey(message: string): string {
    const normalizedMessage = message?.trim().toLowerCase();

    if (!normalizedMessage) {
      return '';
    }

    if (normalizedMessage.includes('email not registered')) {
      return 'auth.login.errors.email-not-registered';
    }

    if (normalizedMessage.includes('wrong password')) {
      return 'auth.login.errors.wrong-password';
    }

    if (normalizedMessage.includes('verify your email')) {
      return 'auth.login.errors.email-not-verified';
    }

    return '';
  }

}




